<template >
  <div>
    <div>
      <span v-if="loading">Loading...</span>
      <!--
              <label for="checkbox">Fabbricati</label>
              <input id="checkbox" v-model="show" type="checkbox" />
              <label for="checkboxTooltip">Tooltip</label>
              <input id="checkboxTooltip" v-model="enableTooltip" type="checkbox" />
              <input v-model="fillColor" type="color" />
              <label for="iconSize">Icone</label>
              <input id="iconSize" v-model="iconSize" type="range" min="1" max="200" value="64" />
              <br />
              -->
    </div>

    <div>
      <l-map
        ref="coreMap"
        :zoom="zoom"
        :options="mapOptions"
        :center="center"
        @ready="mapReady()"
        style="height: 500px; width: 100%"
      >
        <l-tile-layer :url="url" :attribution="attribution" />
        <l-geo-json
          v-if="show"
          :geojson="geojson"
          :options="options"
          :options-style="styleFunction"
        />
        <!-- MARKERS -->

        <!--
                            <l-marker :lat-lng="[42.46394, 12.30622]" :icon="iconOther" />
                 <l-marker :lat-lng="[42.46396, 12.30624]" :icon="iconOther" />
              -->
        <l-marker
          v-for="marker in markers"
          v-bind:key="'ma' + marker.id"
          :lat-lng="marker.latLng"
        >
          <!-- :icon="getIcon(marker)" >-->
          <l-popup>
            <div @click="clickPopup(marker)">
              N.{{ marker.testo }}
              <div
                v-for="loc in marker.locs"
                v-bind:key="'lpopup_' + loc.prgLocatario"
              >
                L: {{ loc.desLoc }}
              </div>
            </div>
          </l-popup>
          <l-icon
            :icon-anchor="staticAnchor"
            :onclick="getOnclickOnMarkerFunction(marker)"
            class-name="markerIcon"
          >
            <div
              class="markerText"
              :onclick="getOnclickOnMarkerFunction(marker)"
            >
              {{ marker.testo }}
            </div>
            <img :src="getIcon(marker).iconUrl" height="32" />
          </l-icon>
        </l-marker>
      </l-map>
    </div>
  </div>
</template>

<script>
import { latLng } from "leaflet";
import {
  LMap,
  LTileLayer,
  LMarker,
  LGeoJson,
  LIcon,
  LPopup,
} from "vue2-leaflet";
import { userService } from "../services/userServices.js";

export default {
  props: {
    _prgIndirizzo: { required: false },
  },
  components: {
    LMap,
    LTileLayer,
    LGeoJson,
    LMarker,
    LIcon,
    LPopup,
  },

  data: () => ({
    location: { color: "red", text: "Pos. non registrata" },
    mapOptions: { maxZoom: 22, maxNativeZoom: 18 },
    iconSize: 64,
    show: true,
    enableTooltip: true,
    zoom: 20,
    defaultMapCenter: [42.46394, 12.30622],
    center: [42.46394, 12.30622],
    geojson: null,
    fillColor: "#e4ce7f",
    url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",

    attribution:
      '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',

    iconCurrent: {
      iconUrl: "/locationDefault.png",
      iconSize: [32, 37],
      iconAnchor: [16, 37],
    },
    iconOther: {
      iconUrl: "/locationOther.png",
      iconSize: [32, 28],
      iconAnchor: [16, 37],
    },

    staticAnchor: [16, 37],
    markers: [],
    tmp4Compile: latLng(47.41322, -1.219482),
    loading: true,
    onError: false,
    currentComune: "xxxx",
    currentAc: { prgAc: -1, fullDes: "please wait ..." },
  }),
  computed: {
    options() {
      return {
        onEachFeature: this.onEachFeatureFunction,
      };
    },
    dynamicSize() {
      return [this.iconSize, this.iconSize * 1.15];
    },
    dynamicAnchor() {
      return [this.iconSize / 2, this.iconSize * 1.15];
    },
    styleFunction() {
      const fillColor = this.fillColor; // important! need touch fillColor in computed for re-calculate when change fillColor
      return () => {
        return {
          weight: 2,
          color: "#ECEFF1",
          opacity: 1,
          fillColor: fillColor,
          fillOpacity: 1,
        };
      };
    },

    onEachFeatureFunction() {
      if (!this.enableTooltip) {
        return () => {};
      }
      return (feature, layer) => {
        layer.bindTooltip(
          "<div>Foglio:" +
            feature.properties.FOGLIO +
            "</div><div>Mappale: " +
            feature.properties.NUMERO +
            "</div>",
          { permanent: false, sticky: true }
        );
      };
    },
  },
  /*watch: {
  prgIndirizzo: {
    // the callback will be called immediately after the start of the observation
    immediate: true, 
    handler (val, oldVal) {
      // do your stuff
      alert(val+'-'+oldVal)
    }
  }*/

  mounted() {
    
  },
  activated() {
    // called on initial mount
    // and every time it is re-inserted from the cache
    var cc = userService.getCurrentComune();
      if (this.currentComune != cc) {
        userService.getComuInfo().then((comuInfo) => {
      this.mapOptions.maxZoom = comuInfo.maxZoom;
      this.mapOptions.maxNativeZoom = comuInfo.maxNativeZoom;
      this.zoom = comuInfo.defaultZoom;
      this.center = comuInfo.center;
      this.defaultMapCenter = comuInfo.center;
    });
      } 
  },
  deactivated() {
    // called when removed from the DOM into the cache
    // and also when unmounted
  },
  methods: {
    mapReady() {
      //var map = this.$refs.coreMap;
      //map.setCenter(this.center);
    },
    clickPopup(m) {
      var map = this.$refs.coreMap;
      map.mapObject.closePopup();
      this.$emit("onChangeIndirizzo", m.prgIndirizzo);

      //alert("click popup "+JSON.stringify(m));
      //this.bind(m.prgIndirizzo) ;
    },
    bind(prgIndirizzo) {
      //var map=this.$refs.coreMap;
      //var marker = LMarker.marker([51.5, -0.09]);
      //marker.getMarkers.addTo(map);
      //marker.bindPopup(('<a href="#" class="speciallink">TestLink</a>').click(function() {
      //  alert("test");
      //})[0]);
      var cc = userService.getCurrentComune();
      if (this.currentComune === cc) {
        this.setCurrentIndirizzo(prgIndirizzo);
      } else {
        this.retrieveGeoJson(cc, prgIndirizzo);
      }
    },
    getIcon(marker) {
      if (marker.current) {
        return this.iconCurrent;
      }
      return this.iconOther;
    },

    truncate(num, fixed) {
      var re = new RegExp("^-?\\d+(?:.\\d{0," + (fixed || -1) + "})?");
      return num.toString().match(re)[0];
    },
    retrieveGeoJson(comune, prgIndirizzo) {
      const shapeFile = "fabbricati.shp";

      userService.getGeoJson(comune, shapeFile).then((data) => {
        //alert(JSON.stringify(this.mapOptions.maxZoom))
        this.mapOptions.maxZoom = data.maxZoom;
        this.mapOptions.maxNativeZoom = data.maxNativeZoom;
        this.zoom = data.defaultZoom;
        this.geojson = data.geoJson;
        this.defaultMapCenter = data.centerlatLng;

        this.currentComune = comune;
        this.loading = false;

        this.setCurrentIndirizzo(prgIndirizzo);
      });
    },
    getPopupDes(m) {
      var des = "";
      for (let index = 0; index < m.locs.length; index++) {
        const element = m.locs[index];
        des = des + " " + element.desLoc;
      }
      return des;
    },
    setCurrentIndirizzo(prgIndirizzo) {
      userService.getMarkers(prgIndirizzo).then((dataM) => {
        this.markers = dataM;

        var centerTmp = this.defaultMapCenter;
        dataM.forEach((element) => {
          element.popupDes = this.getPopupDes(element);
          if (element.current) {
            centerTmp = element.latLng;
            //alert('imposto centro in '+JSON.stringify(element.latLng))

            // alert("found 0 true: "+JSON.stringify(element.latLng) );
          }
        });
        this.center = centerTmp;
        this.setCenter(centerTmp);
        this.loading = false;
      });
    },
    setCenter(center) {
      setTimeout(() => {
        var map = this.$refs.coreMap;
        map.mapObject.panTo(center);

        //map.setCenter(center);
      }, 1000);
      // DOM is now updated
    },
    getOnclickOnMarkerFunction(marker) {
      if (marker) {
        // alert("get funx click on marker:" );
        return function clickOnMarker(marker) {
          alert("click on marker:");
          if (marker.current == true) {
            //console.log("click on Marker:" + marker.markerId);
            //router.push({ path: "/dettaglioNc/" + marker.prgIndirizzo });
          } else {
            alert("click:" + JSON.stringify(marker));
            //console.log("click on Marker:" + marker.markerId);
          }
        };
      }
    },
  },
};
</script>
<style >
.item {
  color: wheat;
}
.itemContainer {
  background-color: black;
  width: 20rem;
}
</style>

